import { useState } from 'react';
import { cn } from '@/lib/utils';
import { ChevronDown } from 'lucide-react';

export function Tooltip({ label, children, side = 'top' }: {
  label: string;
  children: React.ReactNode;
  side?: 'top' | 'bottom' | 'left' | 'right';
}) {
  const [show, setShow] = useState(false);
  return (
    <span className="relative inline-flex" onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
      {children}
      {show && (
        <span
          className={cn(
            'absolute z-[150] px-2 py-1 rounded text-2xs bg-base-elevated border border-border text-text-primary whitespace-nowrap pointer-events-none',
            side === 'top' && 'bottom-full mb-1 left-1/2 -translate-x-1/2',
            side === 'bottom' && 'top-full mt-1 left-1/2 -translate-x-1/2',
            side === 'left' && 'right-full mr-1 top-1/2 -translate-y-1/2',
            side === 'right' && 'left-full ml-1 top-1/2 -translate-y-1/2',
          )}
        >
          {label}
        </span>
      )}
    </span>
  );
}

export function Dropdown({ trigger, children, align = 'right' }: {
  trigger: React.ReactNode;
  children: React.ReactNode;
  align?: 'left' | 'right';
}) {
  const [open, setOpen] = useState(false);
  return (
    <div className="relative" onClick={(e) => e.stopPropagation()}>
      <div onClick={() => setOpen(!open)}>{trigger}</div>
      {open && (
        <>
          <div className="fixed inset-0 z-[80]" onClick={() => setOpen(false)} />
          <div
            className={cn(
              'absolute z-[81] mt-1 surface-elevated py-1 min-w-[180px] animate-fade-in',
              align === 'right' ? 'right-0' : 'left-0',
            )}
            onClick={() => setOpen(false)}
          >
            {children}
          </div>
        </>
      )}
    </div>
  );
}

export function DropdownItem({ children, onClick, danger, icon }: {
  children: React.ReactNode;
  onClick?: () => void;
  danger?: boolean;
  icon?: React.ReactNode;
}) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'w-full flex items-center gap-2.5 px-3 py-1.5 text-xs font-medium text-left transition-colors hover:bg-base-hover',
        danger ? 'text-status-critical' : 'text-text-secondary hover:text-text-primary',
      )}
    >
      {icon && <span className="shrink-0">{icon}</span>}
      {children}
    </button>
  );
}

export function DropdownSeparator() {
  return <div className="h-px bg-border my-1" />;
}
